import { useQuery } from 'react-query';

import { publicExportsApi } from 'src/Services/API';
import { InstructionDto } from 'src/Services/API/generated';

const useFetchExportedInstruction = ({
  token,
  instructionId,
}: {
  token: string;
  instructionId: string;
}) => {
  return useQuery({
    queryKey: ['fetch-exported-instruction', token, instructionId],
    queryFn: async () => {
      return (await publicExportsApi.publicExportsControllerFindEntityById(token, instructionId))
        .data as unknown as InstructionDto;
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export default useFetchExportedInstruction;
